// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__gBfo6","copyright":"Footer_copyright__2YavK","links":"Footer_links__1LUYG","bold":"Footer_bold__2k2GU"};